import React, { useEffect, useState } from 'react';
import {Card, Typography, Container, CardMedia, Box, Button} from '@mui/material';
import LocalLoader from "../Loaders/LocalLoader.js";
import { KBImageComponent } from "./KBImage.js";
import { isMobile } from "../App/utils";
import Divider from "@mui/material/Divider";
import { listApps } from "../API/APP/AppAPI";
import {colorGray, colorText} from "../App/theme";
import ThumbUpOffAltIcon from '@mui/icons-material/FavoriteBorderOutlined';
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import { formatNumber } from "./utils";
import { Link, useNavigate } from 'react-router-dom';

export const AppCenter = () => {
    const [apps, setApps] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigateWrapper = (event, path) => {
        event.preventDefault();
        if (event?.ctrlKey || event?.metaKey) {
            window.open(path, '_blank');
            return;
        } else {
            navigate(path);
        }
    };

    useEffect(() => {
        const fetchApps = async () => {
            setIsLoading(true);
            try {
                const orderBy = 'likes';
                const orderDirection = 'desc';
                const appsData = await listApps(orderBy, orderDirection);
                setApps(appsData);
            } catch (error) {
                console.error('Error fetching apps:', error);
            }
            setIsLoading(false);
        };

        fetchApps();
    }, []);

    const imageSize = isMobile ? '80px' : '120px';

    const iconFontSize = isMobile ? 10 : 'inherit';

    const containerStyle = isMobile ? {marginLeft: '-5%', width: '110%'} : {};

    return (
        <Container style={containerStyle}>
            <Divider style={{ paddingBottom: 30, paddingTop: 15, color: colorText }}>App Center</Divider>
            <LocalLoader open={isLoading} />
            <Box mt={-2} display="flex" flexWrap="wrap" justifyContent={"flex-start"}>
                {apps.map((app) => {
                    const [title, _] = app.kbTitle.split(':');
                    const description = app.kbDescription;
                    return (
                        <Box
                            onClick={(e) => handleNavigateWrapper(e, `/install/${app.appId}`)}
                            key={app.appId}
                            data-testid={`app-install-${app.appId}`}
                            sx={{
                                cursor: 'pointer',
                                width: isMobile ? '100%' : '48%',
                                padding: 1,
                                marginTop: isMobile ? 1 : 2,
                                marginBottom: isMobile ? 0 : 2,
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                            }}
                        >
                            <Card
                                sx={{
                                    display: 'flex',
                                    width: imageSize,
                                    marginRight: 2,
                                    flexShrink: 0,
                                }}
                            >
                                <Link to={`/install/${app.appId}`} style={{ textDecoration: 'none', width: '100%', height: '100%' }}>
                                    <CardMedia
                                        component={KBImageComponent}
                                        height={'100%'}
                                        width={'100%'}
                                        folder={'app-image'}
                                        alt={title}
                                        id={app.appId}
                                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                    />
                                </Link>
                            </Card>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    height: imageSize,
                                    flexGrow: 1
                                }}
                            >
                                <Typography variant="subtitle1"
                                            sx={{ color: colorText, textAlign: 'left', fontWeight: isMobile ? 700 : 'inherit', fontSize: isMobile ? 12 : undefined, lineHeight: '1.4' }}>
                                    {title}
                                </Typography>
                                {description && (
                                    <Typography variant="body2"
                                                sx={{ lineHeight:'1.3', color: colorText, textAlign: 'left', fontSize: isMobile ? 12 : undefined }}>
                                        {description.trim()}
                                    </Typography>
                                )}
                                {!isMobile && <Typography variant="body2" sx={{ marginBottom: '-4px',color: colorGray, alignSelf: 'flex-start', textTransform: 'capitalize', fontSize:12 }}>
                                    {app.category}
                                </Typography>}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: iconFontSize }}>
                                    <ThumbUpOffAltIcon fontSize="small" style={{color:colorGray, fontSize: iconFontSize}} />
                                    <Typography variant="body2" sx={{ color: colorGray, marginRight: 1, fontSize: iconFontSize, marginTop: '2px' }}>
                                        {formatNumber(app.likes)}
                                    </Typography>
                                    <DownloadForOfflineOutlinedIcon fontSize="small" style={{color:colorGray, fontSize: iconFontSize}} />
                                    <Typography variant="body2" sx={{ color: colorGray, fontSize: iconFontSize, marginTop: '2px' }}>
                                        {formatNumber(app.downloads)}
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={(e) => handleNavigateWrapper(e, `/install/${app.appId}`)}
                                        sx={{
                                            // mt: 1,
                                            alignSelf: 'center',
                                            fontSize: '0.75rem',
                                            // top: -20,
                                            marginLeft: isMobile ? 'calc(100% - 175px)': 'calc(100% - 185px)',
                                            minHeight: '24px',
                                            height: '24px',
                                            width: '90px'
                                        }}
                                    >
                                        <span>Launch</span>
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Container>
    );
};